module.exports = __webpack_public_path__ + "img/mobile-page.35ed8adc.png";